/* eslint-disable import/no-default-export */
import Chance from 'chance';
const chance = new Chance();

export default () => ({
  weeks: chance.pickone([0, 2, 4, 8, 12]),
});
